<template>
  <filter-layer
    v-if="activeFilter === Filter.LAYERS && showLayerFilters"
    :organization-settings="organizationSettings!"
    @closed="activeFilter = Filter.NONE"
  />
  <filter-asset
    v-if="activeFilter === Filter.ASSETS"
    v-model="selectedCategories"
    :hide-categories="hideAssetCategories"
    @closed="activeFilter = Filter.NONE"
  />

  <div class="position-absolute d-flex" style="margin: 10px; left: 0; top: 0; z-index: 999">
    <div class="d-flex flex-column align-start" style="gap: 8px">
      <filter-button
        v-if="showLayerFilters"
        icon="layers"
        :badge="isLayerModified"
        :highlight="activeFilter === Filter.LAYERS"
        :text="$t('map.layers')"
        @click="toggleActive(Filter.LAYERS)"
      />
      <filter-button
        icon="$asset"
        :badge="isAssetModified"
        :highlight="activeFilter === Filter.ASSETS"
        :text="$t('assets.title')"
        @click="toggleActive(Filter.ASSETS)"
      />

      <slot name="custom-buttons" />
    </div>
  </div>
</template>

<script setup lang="ts">
const { organizationSettings } = defineProps<{
  hideAssetCategories?: boolean
  organizationSettings: OrganizationSettings
}>()

const authStore = useAuthStore()
const { currentOrganization } = storeToRefs(authStore)

const selectedCategories = defineModel<Array<string>>("selectedCategories", { default: () => [] })

const layersPdok = useLocalStorage<Array<string>>("ol:layer-pdok", [])
const layersDuopp = useLocalStorage<Array<string>>(`ol-${currentOrganization.value}:layer-duopp`, [])
const layersGIS = useLocalStorage<Array<string>>(`ol-${currentOrganization.value}:layer-gis`, [])
const showRelations = useLocalStorage<boolean>("ol:asset-relations", false)

enum Filter {
  NONE = "NONE",
  LAYERS = "LAYERS",
  ASSETS = "ASSETS",
  TICKETS = "TICKETS",
}

const activeFilter = ref(Filter.NONE)

const toggleActive = (filter: Filter) => {
  activeFilter.value = activeFilter.value === filter ? Filter.NONE : filter
}

const showLayerFilters = computed(() => {
  const { geoLayers, geoLayersDuoPP, geoLayersGIS } = organizationSettings
  return geoLayers || geoLayersDuoPP || geoLayersGIS
})

const isLayerModified = computed(() => layersPdok.value.length > 0 || layersDuopp.value.length > 0 || layersGIS.value.length > 0)
const isAssetModified = computed(() => selectedCategories.value.length > 0 || showRelations.value)
</script>
